
















































































































































































































































































































import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwModal, SwModalBody, SwModalFooter } from '@libs-uuif/shared/sw-modal';
import { SwForm, SwFormRow } from '@libs-uuif/shared/sw-form';
import { SwTextfield, SwTextarea } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { SwButton } from '@libs-uuif/shared/sw-button';
import { SelectOption, SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import RegexValidators from '../../../shared/regex-validators';
import { MswApiService } from '../../../shared/msw-api-service';
import { InfoState } from '../../../core';
const ccsPrefix = 'tenant-detail';

@Component({
  components: {
    SwModalFooter,
    SwModalBody,
    SwModal,
    SwButton,
    SwForm,
    SwTextfield,
    SwFormRow,
    SwSelect,
    SwTextarea,
  },
})

export default class TenantDetail extends SwExtendedVue {
  @Prop({ required: true })
  step: any;
  @Prop({ required : false })
  showTenantDetail: boolean;
  @Prop({ required : true })
  tenantResponse : any;
  cssPrefix = ccsPrefix;
  contactName : string = '';
  country: string = 'US';
  zipCode : string = '';
  state : string = '';
  province : string = '';
  city : string = '';

  streetAddress : string = '';
  emailAddress : string = '';
  step1 : boolean = true;
  step2: boolean = false;
  showErrorMsg : boolean = false;
  inValidEmail : boolean = false;
  inValidPhone : boolean = false;
  companyName :string = '';
  phoneNumber :string = '';
  tenantDetail : any ;
  tenantDetailRequest : any;
  additionalNotes: string = '';
  showErrorMaxLength: boolean = false;
  stateOptionCA: SelectOption[] = [{ id: 'AB' , label: 'Alberta', value: 'Alberta' },
            { id: 'BC' , label: 'British Columbia', value: 'British Columbia' },
            { id: 'MB', label: 'Manitoba', value: 'Manitoba' },
            { id: 'ON' , label: 'Ontario' , value: 'Ontario' },
            { id: 'MB' , label: 'Manitoba' , value: 'Manitoba' },
            { id: 'NF' , label: 'Newfoundland and Labrador',  value: 'Newfoundland and Labrador' },
            { id: 'NB' , label: 'New Brunswick' , value: 'New Brunswick' },
            { id: 'NS' , label: 'Nova Scotia' , value: 'Nova Scotia' },
            { id: 'NT' , label: 'Northwest Territories',  value: 'Northwest Territories' },
            { id: 'NU' , label: 'Nunavut' , value: 'Nunavut' },
            { id: 'YT' , label: 'Yukon', value: 'Yukon' },
            { id: 'SK' , label: 'Saskatchewan',  value: 'Saskatchewan' },
            { id: 'PE' , label: 'Prince Edward Island', value: 'Prince Edward Island' },
            { id: 'QC' , label: 'Quebec' , value: 'Quebec' }];

  stateOptionUS: SelectOption[] = [{ id: 'AK', label: 'Alaska' , value : 'Alaska' },
            { id: 'AL' , label: 'Alabama', value: 'Alabama' },
            { id: 'AR' , label: 'Arkansas', value: 'Arkansas' },
            { id: 'AZ' , label: 'Arizona', value: 'Arizona' },
            { id: 'CA' , label: 'California', value: 'California' },
            { id: 'CO' , label: 'Colorado', value: 'Colorado' },
            { id: 'CT' , label: 'Connecticut', value: 'Connecticut' },
            { id: 'DC' , label: 'District of Columbia', value: 'District of Columbia' },
            { id: 'DE' , label: 'Delaware', value: 'Delaware' },
            { id: 'FL' , label: 'Florida', value: 'Florida' },
            { id: 'GA' , label: 'Georgia', value: 'Georgia' },
            { id: 'GU' , label: 'Guam', value: 'Guam' },
            { id: 'HI' , label: 'Hawaii', value: 'Hawaii' },
            { id: 'IA' , label: 'Iowa', value: 'Iowa' },
            { id: 'ID' , label: 'Idaho', value: 'Idaho' },
            { id: 'IL' , label: 'Illinois', value: 'Illinois' },
            { id: 'IN' , label: 'Indiana',  value: 'Indiana' },
            { id: 'KS' , label: 'Kansas' , value: 'Kansas' },
            { id: 'KY' , label: 'Kentucky',  value: 'Kentucky' },
            { id: 'LA' , label: 'Louisiana', value: 'Louisiana' },
            { id: 'MA' , label: 'Massachusetts', value: 'Massachusetts' },
            { id: 'MD' , label: 'Maryland' , value:'Maryland' },
            { id: 'ME' , label: 'Maine' , value: 'Maine' },
            { id: 'MI' , label: 'Michigan',  value: 'Michigan' },
            { id: 'MN' , label: 'Minnesota',  value: 'Minnesota' },
            { id: 'MO' , label: 'Missouri' , value: 'Missouri' },
            { id: 'MS' , label: 'Mississippi',  value: 'Mississippi' },
            { id: 'MT' , label: 'Montana' , value : 'Montana' },
            { id: 'NC' , label: 'North Carolina' , value: 'North Carolina' },
            { id: 'ND' , label: 'North Dakota' , value: 'North Dakota' },
            { id: 'NE' , label: 'Nebraska',  value: 'Nebraska' },
            { id: 'NH' , label: 'New Hampshire',  value: 'New Hampshire' },
            { id: 'NJ' , label: 'New Jersey',  value: 'New Jersey' },
            { id: 'NM' , label: 'New Mexico',  value: 'New Mexico' },
            { id: 'NV' , label: 'Nevada',  value: 'Nevada' },
            { id: 'NY' , label: 'New York' , value: 'New York' },
            { id: 'OH' , label: 'Ohio',  value: 'Ohio' },
            { id: 'OK' , label: 'Oklahoma',  value: 'Oklahoma' },
            { id: 'OR' , label: 'Oregon' , value: 'Oregon' },
            { id: 'PA' , label: 'Pennsylvania',  value: 'Pennsylvania' },
            { id: 'RI' , label: 'Rhode Island' , value: 'Rhode Island' },
            { id: 'SC' , label: 'South Carolina',  value: 'South Carolina' },
            { id: 'SD' , label: 'South Dakota',  value: 'South Dakota' },
            { id: 'TN' , label: 'Tennessee',  value: 'Tennessee' },
            { id: 'TX' , label: 'Texas', value: 'Texas' },
            { id: 'UT' , label: 'Utah' , value: 'Utah' },
            { id: 'VA' , label: 'Virginia',  value: 'Virginia' },
            { id: 'VI' , label: 'Virgin Islands' , value : 'Virgin Islands' },
            { id: 'VT' , label: 'Vermont' , value: 'Vermont' },
            { id: 'WA' , label: 'Washington',  value: 'Washington' },
            { id: 'WI' , label: 'Wisconsin',  value: 'Wisconsin' },
            { id: 'WV' , label: 'West Virginia',  value: 'West Virginia' },
            { id: 'WY' , label: 'Wyoming',  value: 'Wyoming' }];

  countryOption: SelectOption[] = [];
  countryDisplay : string = '';
  stateDisplay : string = '';
  errMsg : string = '';
  suggestedAddressObj = {
    state : '',
    city : '',
    country : '',
    streetAddress : '',
    zipCode : '',
    stateCode : '',
    countryCode : '',
    additinalComments: '',
    province: '',
  };
  suggestedAddressFlag : boolean = false;
  showInvalidAddress : boolean = false;
  created() {
    if (this.step === 'edit') {
      this.getCustomerInfo();
    } else {
      this.getCountriesFromServer();
    }
    this.tenantDetail = this.tenantResponse.response;
    this.tenantDetailRequest = this.tenantResponse.request;
    console.warn(this.tenantDetail);
  }
  @Watch('step')
  watchStep() {
    if (this.step === 'created') {
      this.step1 = true;
      this.step2 = false;
    } else if (this.step === 'edit') {
      this.step2 = true;
      this.step1 = false;
    }
    console.warn(this.step);
  }
  detailSubmit() {
    this.showErrorMsg = true;
    if (this.additionalNotes !== '' && this.additionalNotes.length > 512) {
      this.showErrorMaxLength = true;
      return;
    }
    // tslint:disable-next-line:max-line-length
    if (this.companyName.trim() !== '' && this.contactName.trim() !== '' && this.country !== '' && this.zipCode.trim() !== '' && this.city.trim() !== '' && this.streetAddress.trim() !== '' && this.emailAddress.trim() !== '' && (this.state !== '' || this.province !== '')) {
      if (this.step === 'created') {
        console.warn('created');
        const createProductGroupRequest = {
          productGroup: this.tenantDetailRequest.productGroup,
          partyGroupId: this.tenantDetailRequest.partyGroupId,
          userGrpName: this.tenantDetailRequest.userGrpName,
          source: 'WORKSPACE',
          isAddressVerified : 'TRUE',
          tenantAddress : {
            companyName: this.companyName,
            contactName:  this.contactName,
            emailAddress: this.emailAddress,
            streetAddress: this.streetAddress,
            city: this.city,
            state: this.state,
            zipCode: this.zipCode,
            country: this.country,
            phoneNumber: this.phoneNumber,
            province: this.province,
            additionalComments: this.additionalNotes,
          },
        };
        this.$store.commit('startLoading');
        MswApiService.createCustomer.postNewCustomer(createProductGroupRequest)
      .then((resp: any) => {
        if (resp.msgCode === 'MSWAPP:CREATPRODUCTGROUPSUCCESS') {
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
          this.$emit('loadData', resp);
          this.modalClose();
        } else if (resp.msgCode === 'MSWAPP:TENANTADDRESSSUGGESTION') {
          this.suggestedMethod(resp);
        } else if (resp.msgCode === 'MSWAPP:INVALIDADDRESS') {
          if (this.country === 'US') {
            this.stateOptionUS.forEach((ele :any) => {
              if (ele.id === this.state) {
                this.countryDisplay = 'United States';
                this.stateDisplay = ele.label;
              }
            });
          } else {
            this.stateOptionCA.forEach((ele :any) => {
              if (ele.id === this.state) {
                this.countryDisplay = 'Canada';
                this.stateDisplay = ele.label;
              }
            });
          }
          this.step1 = false;
          this.step2 = false;
          this.suggestedAddressFlag = true;
          this.showInvalidAddress = true;
          this.errMsg = resp.msgDesc;
          const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
        this.$store.commit('stopLoading');
      });
      } else if (this.step === 'edit') {
        console.warn('edit');
        console.warn(this.tenantResponse);
        const request = {
          productGroupId : this.tenantResponse.data.productGroupId,
          tenantAddress : {
            companyName : this.companyName,
            contactName : this.contactName,
            emailAddress : this.emailAddress,
            streetAddress : this.streetAddress,
            city : this.city,
            state : this.state,
            zipCode : this.zipCode,
            country : this.country,
            phoneNumber : this.phoneNumber,
            province : this.province,
            additionalComments: this.additionalNotes,
          },
        };
        console.warn(request);
        this.$store.commit('startLoading');
        this.$store
          .dispatch('MswProductsStoreModule/updateTenantInfo' , request)
          .then((resp: any) => {
            this.$store.commit('stopLoading');
            if (resp.msgCode === 'MSWAPP:UPDATETENANTADDRESSUCCESS') {
              const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
              this.$store.commit('displayMessage', message);
              this.modalClose();
            } else if (resp.msgCode === 'MSWAPP:TENANTADDRESSSUGGESTION') {
              this.suggestedMethod(resp);
            } else if (resp.msgCode === 'MSWAPP:INVALIDADDRESS' || resp.msgCode === 'MSWAPP:UPDATETENANTADDRESSFAILUERE') {
              if (this.country === 'US') {
                this.stateOptionUS.forEach((ele :any) => {
                  if (ele.id === this.state) {
                    this.countryDisplay = 'United States';
                    this.stateDisplay = ele.label;
                  }
                });
              } else if (this.country === 'CA') {
                this.stateOptionCA.forEach((ele :any) => {
                  if (ele.id === this.state) {
                    this.countryDisplay = 'Canada';
                    this.stateDisplay = ele.label;
                  }
                });
              } else {
                this.stateDisplay = this.province;
                this.countryDisplay = this.countryOption.filter((ele : any) => {
                  return ele.id === this.country;
                })[0].label
                .toString();
              }
              this.step1 = false;
              this.step2 = false;
              this.suggestedAddressFlag = true;
              this.showInvalidAddress = true;
              this.errMsg = resp.msgDesc;
              const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
              this.$store.commit('displayMessage', message);
            } else {
              const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
              this.$store.commit('displayMessage', message);
            }
            console.warn(resp);
          });
      }
    } else {
      this.showErrorMsg = true;
    }
  }

// tslint:disable-next-line:ter-indent
suggestedMethod(resp : any) {
  this.suggestedAddressObj.city = resp.addressResp.city && resp.addressResp.city !== '' ? resp.addressResp.city : this.city;
  if (resp.addressResp.stateCode !== '' && resp.addressResp.stateCode) {
    this.suggestedAddressObj.country = resp.addressResp.country;
    if (resp.addressResp.country === 'United States' || resp.addressResp.country === 'US') {
      console.warn(this.state);
      this.countryDisplay = 'United States';
      this.suggestedAddressObj.country = 'United States';
      this.suggestedAddressObj.countryCode = 'US';
      this.stateOptionUS.forEach((ele :any) => {
        if (ele.id === this.state) {
          this.stateDisplay = ele.label;
        }
        if (ele.id === resp.addressResp.stateCode) {
          this.suggestedAddressObj.stateCode = ele.id;
          this.suggestedAddressObj.state = ele.label;
        }
      });
    } else if (resp.addressResp.country === 'Canada' || resp.addressResp.country === 'CA') {
      this.countryDisplay = 'Canada';
      this.suggestedAddressObj.country = 'Canada';
      this.suggestedAddressObj.countryCode = 'CA';
      this.stateOptionCA.forEach((ele :any) => {
        if (ele.id === this.state) {
          this.stateDisplay = ele.label;
        }
        if (ele.id === resp.addressResp.stateCode) {
          this.suggestedAddressObj.stateCode = ele.id;
          this.suggestedAddressObj.state = ele.label;
        }
      });
    } else {
      this.assignOtherThanUSandCA(resp);
    }
  } else {
    // tslint:disable-next-line:ter-indent
    this.suggestedAddressObj.country = resp.addressResp.country;
    if (resp.addressResp.country === 'United States' || resp.addressResp.country === 'US') {
      this.suggestedAddressObj.countryCode = 'US';
      this.suggestedAddressObj.country = 'United States';
      this.countryDisplay = 'United States';
      this.stateOptionUS.forEach((ele :any) => {
        if (ele.id === this.state) {
          this.stateDisplay = ele.label;
          this.suggestedAddressObj.stateCode = ele.id;
        }
      });
    } else if (resp.addressResp.country === 'Canada' || resp.addressResp.country === 'CA') {
      this.suggestedAddressObj.countryCode = 'CA';
      this.suggestedAddressObj.country = 'Canada';
      this.countryDisplay = 'Canada';
      this.stateOptionCA.forEach((ele :any) => {
        if (ele.id === this.state) {
          this.stateDisplay = ele.label;
          this.suggestedAddressObj.stateCode = ele.id;
        }
      });
    } else {
      this.assignOtherThanUSandCA(resp);
    }
    this.suggestedAddressObj.state = this.stateDisplay;
  }
  this.suggestedAddressObj.zipCode = resp.addressResp.zipCode && resp.addressResp.zipCode !== '' ? resp.addressResp.zipCode : this.zipCode;
            // tslint:disable-next-line:max-line-length
  this.suggestedAddressObj.streetAddress = resp.addressResp.address && resp.addressResp.address !== '' ? resp.addressResp.address : this.streetAddress;
  console.warn(resp.addressResp.country && resp.addressResp.state);
  console.warn(resp.addressResp.state);
  if (resp.addressResp.country && (resp.addressResp.stateCode || resp.addressResp.state)) {
    console.warn('true');
    this.step1 = false;
    this.step2 = false;
    this.suggestedAddressFlag = true;
    this.showInvalidAddress = false;
  } else {
    console.warn('false');
    this.confirmSubmit(2);
  }
}
  assignOtherThanUSandCA(resp : any) {
    if (resp.addressResp.country.length === 2) {
      const countryIndex = this.countryOption.findIndex((ele : any) => ele.id === resp.addressResp.country);
      const countryIndexGiven =  this.countryOption.findIndex((ele : any) => ele.id === this.country);
      if (countryIndex > -1) {
        this.suggestedAddressObj.country = this.countryOption[countryIndex].label.toString();
        this.suggestedAddressObj.countryCode = this.countryOption[countryIndex].id;
      }
      if (countryIndexGiven > -1) {
        this.countryDisplay = this.countryOption[countryIndexGiven].label.toString();
      }
    }
    if (resp.addressResp.stateCode !== '' && resp.addressResp.province !== '') {
      this.suggestedAddressObj.stateCode = resp.addressResp.stateCode;
      this.suggestedAddressObj.state = resp.addressResp.province;
      this.suggestedAddressObj.province = resp.addressResp.province;
    }
    if (this.province !== '') {
      this.stateDisplay = this.province;
    }

  }
// tslint:disable-next-line:ter-indent
confirmSubmit(param : any) {
  if (this.step === 'created') {
    const createProductGroupRequest = {
      productGroup: this.tenantDetailRequest.productGroup,
      partyGroupId: this.tenantDetailRequest.partyGroupId,
      userGrpName: this.tenantDetailRequest.userGrpName,
      source: 'WORKSPACE',
      isAddressVerified : 'TRUE',
      isAddressVerificationCompleted : 'TRUE',
      tenantAddress : {
        companyName: this.companyName,
        contactName:  this.contactName,
        emailAddress: this.emailAddress,
        streetAddress: param === 2 ? this.streetAddress : this.suggestedAddressObj.streetAddress,
        city: param === 2 ? this.city : this.suggestedAddressObj.city,
        state: param === 2 ? this.state :this.suggestedAddressObj.stateCode,
        zipCode: param === 2 ? this.zipCode : this.suggestedAddressObj.zipCode,
        country: param === 2 ? this.country :this.suggestedAddressObj.countryCode,
        phoneNumber: this.phoneNumber,
        province: param === 2 ? this.province : this.suggestedAddressObj.hasOwnProperty('province') ? this.suggestedAddressObj.province : '',
        additionalComments: this.additionalNotes,
      },
    };
    console.warn(createProductGroupRequest);
    this.$store.commit('startLoading');
    MswApiService.createCustomer.postNewCustomer(createProductGroupRequest)
        .then((resp: any) => {
          this.$store.commit('stopLoading');
          if (resp.operationStatus === 'OK') {
            const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
            this.$emit('loadData', resp);
            this.modalClose();
          } else {
            const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
          }
        });
  } else if (this.step === 'edit') {
    const createProductGroupRequest = {
      productGroupId : this.tenantResponse.data.productGroupId,
      isAddressVerificationCompleted : 'TRUE',
      tenantAddress : {
        companyName: this.companyName,
        contactName:  this.contactName,
        emailAddress: this.emailAddress,
        streetAddress: param === 2 ? this.streetAddress : this.suggestedAddressObj.streetAddress,
        city: param === 2 ? this.city : this.suggestedAddressObj.city,
        state: param === 2 ? this.state :this.suggestedAddressObj.stateCode,
        zipCode: param === 2 ? this.zipCode : this.suggestedAddressObj.zipCode,
        country: param === 2 ? this.country :this.suggestedAddressObj.countryCode,
        phoneNumber: this.phoneNumber,
        province: param === 2 ? this.province : this.suggestedAddressObj.hasOwnProperty('province') ? this.suggestedAddressObj.province : '',
        additionalComments: this.additionalNotes,
      },
    };
    console.warn(createProductGroupRequest);
    this.$store.commit('startLoading');
    this.$store
      .dispatch('MswProductsStoreModule/updateTenantInfo' , createProductGroupRequest)
        .then((resp: any) => {
          this.$store.commit('stopLoading');
          if (resp.operationStatus === 'OK') {
            const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
            // this.$emit('loadData', true);
            this.modalClose();
          } else {
            const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
            this.$store.commit('displayMessage', message);
          }
        });
  }
}
// tslint:disable-next-line:ter-indent
modalClose() {
  this.$emit('request-close', true);
}
// tslint:disable-next-line:ter-indent
goBack() {
  this.step1 = true;
  this.step2 = false;
  this.suggestedAddressFlag = false;
}
// tslint:disable-next-line:ter-indent
checkEmail() {
  const regexStr =  new RegExp(RegexValidators.email);
  this.inValidEmail = !regexStr.test(this.emailAddress);
}
// tslint:disable-next-line:ter-indent
checkPhone() {
  const regexStr = new RegExp(RegexValidators.phoneNo);
  this.inValidPhone = !regexStr.test(this.phoneNumber);
}
// tslint:disable-next-line:ter-indent
getCountriesFromServer() {
  this.$store
      .dispatch('MswProductsStoreModule/getCountries')
      .then((res: any) => {
        this.$store.commit('stopLoading');
        this.assignCountryVariable(res);
      });
}
// tslint:disable-next-line:ter-indent
skipTenant() {
  if (this.tenantDetail.isSkipOptionRequired === 'YES') {
    const createProductGroupRequest = {
      productGroup: this.tenantDetailRequest.productGroup,
      partyGroupId: this.tenantDetailRequest.partyGroupId,
      userGrpName: this.tenantDetailRequest.userGrpName,
      source: 'WORKSPACE',
      isAddressVerified : 'TRUE',
      isAddressVerificationCompleted : 'TRUE',
      tenantAddress : {},
    };
    this.$store.commit('startLoading');
    MswApiService.createCustomer.postNewCustomer(createProductGroupRequest)
      .then((resp: any) => {
        if (resp.msgCode === 'MSWAPP:CREATPRODUCTGROUPSUCCESS') {
          const message: InfoState = { infoType: 'success', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
          this.$emit('loadData', resp);
          this.modalClose();
        } else {
          const message: InfoState = { infoType: 'failed', infoMsg: resp.msgDesc };
          this.$store.commit('displayMessage', message);
        }
        this.$store.commit('stopLoading');
        // console.warn(resp);
      });
  }
}
// tslint:disable-next-line:ter-indent
editMode() {
  this.step1 = true;
  this.step2 = false;
}
  assignCountryVariable(res : any) {
    this.countryOption = res.content.lstCountries.map((each: any) => {
      return {
        id: each.countryCode,
        label: each.countryName,
        value: each.countryCode,
      };
    });
  }
// tslint:disable-next-line:ter-indent
getCustomerInfo() {
  console.warn(this.tenantResponse);
  Promise.all([this.$store.dispatch('MswProductsStoreModule/getTenantInfo' , { productGroupId: this.tenantResponse.data.productGroupId }),
    this.$store.dispatch('MswProductsStoreModule/getCountries')])
      .then((response: any) => {
        this.assignCountryVariable(response[1]);
        const resp = Object.assign({}, response[0]);
        if (resp.msgCode === 'MSWAPP:TENANTADDRESSNOTFOUND') {
          this.step1 = true;
          this.step2 = false;
        } else if (resp.msgCode === 'MSWAPP:TENANTADDRESSSUCCESS') {
          this.step2 = true;
          this.step1 = false;
          this.companyName = resp.tenantAddress.companyName;
          this.contactName = resp.tenantAddress.contactName;
          this.emailAddress = resp.tenantAddress.emailAddress;
          this.streetAddress = resp.tenantAddress.streetAddress;
          this.city = resp.tenantAddress.city;
          if (resp.tenantAddress.state !== '') {
            this.stateDisplay = resp.tenantAddress.state;
            console.warn(this.stateDisplay);
            if (resp.tenantAddress.country === 'United States') {
              console.warn('got in us');
              this.state = this.stateOptionUS.filter((ele : any) => {
                return ele.label === this.stateDisplay;
              })[0].id;
              console.warn(this.stateOptionUS.filter((ele : any) => {
                return ele.label === this.stateDisplay;
              }));
            } else {
              this.state = this.stateOptionCA.filter((ele : any) => {
                return ele.label === this.stateDisplay;
              })[0].id;
            }
            console.warn(this.state);
          }
          this.zipCode = resp.tenantAddress.zipCode;
          this.countryDisplay = resp.tenantAddress.country;
          this.country = this.countryOption.filter((ele : any) => {
                return ele.label === this.countryDisplay;
          })[0].id;
          console.warn(this.country);
          this.phoneNumber = resp.tenantAddress.phoneNumber;
          this.province = resp.tenantAddress.province;
          this.additionalNotes = resp.tenantAddress.additionalComments;
          this.step2 = true;
          this.step1 = false;
        }
        this.$store.commit('stopLoading');
        console.warn(resp);
      });
}
}
